import { FormControlLabel, FormControlLabelProps, SxProps, Theme } from '@mui/material';
import BaseCheckbox, { BaseCheckboxProps } from '../BaseCheckbox';
import CheckboxLabel, { CheckboxLabelProps } from './CheckboxLabel';

export type CheckboxWithLabelProps = Omit<
    FormControlLabelProps,
    'control' | 'sx' | 'label' | 'onChange'
> &
    CheckboxLabelProps & {
        checkboxProps?: BaseCheckboxProps;
        checked?: boolean;
        onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
        sx?: SxProps<Theme>;
    };

const CheckboxWithLabel = ({
    label,
    bold,
    labelStyles,
    sx,
    gap,
    checkboxProps,
    checked,
    onChange,
    ...rest
}: CheckboxWithLabelProps) => {
    return (
        <FormControlLabel
            sx={{ margin: '0', height: '20px', ...sx }}
            control={<BaseCheckbox checked={checked} onChange={onChange} {...checkboxProps} />}
            label={<CheckboxLabel label={label} bold={bold} gap={gap} labelStyles={labelStyles} />}
            {...rest}
        />
    );
};

export default CheckboxWithLabel;
